module.exports = global["Translations"] = require("-!/var/www/ridewithgps.com/releases/20261103180724/node_modules/babel-loader/lib/index.js?{\"presets\":[\"es2015\"]}!/var/www/ridewithgps.com/releases/20261103180724/node_modules/eslint-loader/index.js!/var/www/ridewithgps.com/releases/20261103180724/node_modules/eslint-loader/index.js!./translations.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Translations!./~/babel-loader/lib?{"presets":["es2015"]}!./~/eslint-loader!./public/javascripts/translations.js-exposed
// module id = 140
// module chunks = 0